import React from 'react';
import SplashScreen from './shared/SplashScreen';
import { useSelector } from 'react-redux';
import SuperAdminDashboard from './SuperAdminDashboard';
import AdminDashboard from './AdminDashboard';
import UserDashboard from './UserDashboard';


const Dashboard = () => {
  const user = useSelector((state) => state.auth.user);
  const hydrated = useSelector((state) => state.auth.hydrated);

  if (!hydrated) return <SplashScreen />; 
  if (!user) return <p className="text-center text-gray-500 mt-8">No user found.</p>;


  switch (user.role) {
    case "super_admin":
      return <SuperAdminDashboard />;
    case "admin":
      return <AdminDashboard />;
    case "user":
      return <UserDashboard />;
    default:
      return <p className="text-center text-red-500 mt-8">Unauthorized or unknown role.</p>;
  }
}

export default Dashboard